'use client';
import { useState } from 'react';
import styles from './CheckoutForm.module.css';

export default function CheckoutForm() {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className={styles.formCard}>
      <h3 className={styles.title}>Shipping Information</h3>

      <form className={styles.form}>
        <input
          type="email"
          name="email"
          placeholder="Email address"
          value={formData.email}
          onChange={handleChange}
          className={styles.input}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone number"
          value={formData.phone}
          onChange={handleChange}
          className={styles.input}
          required
        />

        <input
          type="text"
          name="address"
          placeholder="Street address"
          value={formData.address}
          onChange={handleChange}
          className={styles.input}
          required
        />

        <div className={styles.row}>
          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            className={styles.input}
            required
          />
          <input
            type="text"
            name="postalCode"
            placeholder="Postal code"
            value={formData.postalCode}
            onChange={handleChange}
            className={styles.input}
            required
          />
        </div>
      </form>
    </div>
  );
}
